import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {NgClass} from '@angular/common';

@Component({
	selector: 'app-toggle-button',
	templateUrl: './toggle-button.component.html',
	styleUrls: ['./toggle-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ReactiveFormsModule, NgClass]
})
export class ToggleButtonComponent {
	@Input() toggleInput: FormControl;
	@Input() scale = 1;
	@Input() locked = false;
	@Input() color: 'accent' | 'accent-secondary' = 'accent';
}
